import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { useCompany } from '../context/CompanyContext';
import { Button, Toast } from '../components/UI';
import { fmt } from '../utils/formatters';

export default function ProfileScreen() {
    const navigate = useNavigate();
    const { profile, updateProfile, clearProfile } = useUser();
    const { company, clearCompany } = useCompany();

    const [name, setName] = useState(profile.name || '');
    const [phone, setPhone] = useState(profile.phone || '');
    const [email, setEmail] = useState(profile.email || '');
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        updateProfile({ name, phone, email });
        setSaving(false);
        Toast.show({ type: 'success', text1: 'Profile Saved' });
    };

    const handleClearProfile = () => {
        clearProfile();
        setName(''); setPhone(''); setEmail('');
        Toast.show({ type: 'success', text1: 'Profile Cleared' });
    };

    const inputStyle = {
        display: 'block', width: '100%', backgroundColor: 'var(--bg-input)',
        border: '1px solid var(--border)', borderRadius: 10, padding: '10px 14px',
        color: 'var(--text-primary)', fontSize: 15, fontFamily: 'var(--font-body)',
        marginBottom: 12,
    };
    const labelStyle = {
        display: 'block', color: 'var(--text-muted)', fontSize: 11, fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4, marginTop: 12,
    };
    const cardStyle = {
        backgroundColor: 'var(--bg-card)', borderRadius: 20, padding: 20,
        border: '1px solid var(--border)', marginBottom: 16,
    };

    return (
        <div style={{ padding: 24 }}>
            {/* Back */}
            <button onClick={() => navigate(-1)} style={{
                background: 'none', border: 'none',
                color: 'var(--brand-300)', fontSize: 14, cursor: 'pointer', marginBottom: 16, padding: 0
            }}>
                ← Back
            </button>

            {/* Avatar */}
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
                <div style={{
                    width: 88, height: 88, borderRadius: '50%', backgroundColor: 'var(--bg-card)',
                    border: '2px solid var(--brand-500)', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', margin: '0 auto 12px',
                    fontFamily: 'var(--font-mono)', fontSize: 28, fontWeight: 700, color: 'var(--brand-300)'
                }}>
                    {profile.name ? fmt.initials(profile.name) : '👤'}
                </div>
                {profile.name && <p style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700 }}>{profile.name}</p>}
                {profile.email && <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 2 }}>{profile.email}</p>}
            </div>

            {/* Edit form */}
            <div style={cardStyle}>
                <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Your Information</h2>
                <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>
                    Saved locally — used to pre-fill booking forms and retrieve your Bookings.
                </p>
                <label style={labelStyle}>Full Name</label>
                <input value={name} onChange={e => setName(e.target.value)} placeholder="John Smith" style={inputStyle} />
                <label style={labelStyle}>Phone Number</label>
                <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+123456789" type="tel" style={inputStyle} />
                <label style={labelStyle}>Email Address</label>
                <input value={email} onChange={e => setEmail(e.target.value)} placeholder="you@yourdomain.com" type="email" style={inputStyle} />
                <Button label={saving ? 'Saving…' : 'Save Profile'} onClick={handleSave} loading={saving} fullWidth style={{ marginTop: 4 }} />
            </div>

            {/* Connected company */}
            {company && (
                <div style={cardStyle}>
                    <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Connected Business</h2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                        <div style={{
                            width: 44, height: 44, borderRadius: '50%', backgroundColor: 'var(--bg-surface)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22
                        }}>🏢</div>
                        <div>
                            <p style={{ fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 700 }}>{company.companyName}</p>
                            <p style={{ color: 'var(--text-muted)', fontSize: 12, textTransform: 'capitalize' }}>{company.industry}</p>
                        </div>
                    </div>
                    <Button label="Switch Business" variant="outline" onClick={() => { clearCompany(); navigate('/'); }} fullWidth />
                </div>
            )}

            {/* Privacy */}
            <div style={cardStyle}>
                <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Data & Privacy</h2>
                <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 12, lineHeight: 1.5 }}>
                    Your Profile is stored only in this browser. No Account is required.
                </p>
                <button onClick={handleClearProfile} style={{
                    background: 'none', border: 'none',
                    color: 'var(--danger)', fontSize: 13, cursor: 'pointer', padding: 0
                }}>
                    Clear Profile Data
                </button>
            </div>

            <p style={{ color: 'var(--text-muted)', fontSize: 12, textAlign: 'center', marginTop: 8 }}>GAAFcrm v1.0.0</p>
        </div>
    );
}
